(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    const initCarousel = () => {
    const carousels = document.querySelectorAll('.carousel__container');

    carousels.forEach((carousel) => {
      const slides = carousel.querySelectorAll('.carousel__slide');
      const dots = carousel.querySelectorAll('.carousel__dot');
      const prevButton = carousel.querySelector('[data-carousel="prev"]');
      const nextButton = carousel.querySelector('[data-carousel="next"]');

      let currentSlide = 0;
      let autoplayInterval = null;

      const showSlide = (index) => {
        // Remove active classes
        slides.forEach((slide) => slide.classList.remove('carousel__slide--active'));
        dots.forEach((dot) => dot.classList.remove('carousel__dot--active'));

        // Add active classes
        if (slides[index]) {
          slides[index].classList.add('carousel__slide--active');
        }
        if (dots[index]) {
          dots[index].classList.add('carousel__dot--active');
        }

        currentSlide = index;
      };

      const nextSlide = () => {
        const next = (currentSlide + 1) % slides.length;
        showSlide(next);
      };

      const prevSlide = () => {
        const prev = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
        showSlide(prev);
      };

      const startAutoplay = () => {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
        }
        autoplayInterval = setInterval(nextSlide, 5000);
      };

      const stopAutoplay = () => {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      };

      // Event listeners
      if (prevButton) {
        prevButton.addEventListener('click', () => {
          stopAutoplay();
          prevSlide();
          startAutoplay();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          stopAutoplay();
          nextSlide();
          startAutoplay();
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          stopAutoplay();
          showSlide(index);
          startAutoplay();
        });
      });

      // Pause on hover - target the entire carousel area
      const carouselArea = carousel.querySelector('.carousel__slides') || carousel;

      carouselArea.addEventListener('mouseenter', () => {
        stopAutoplay();
      });

      carouselArea.addEventListener('mouseleave', () => {
        startAutoplay();
      });

      // Start autoplay
      startAutoplay();
    });
  };

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', initCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["learn-more-button"] && !Shopify.designMode) return;
  try {
    // Handle smooth scroll without changing URL
  document.addEventListener('DOMContentLoaded', function () {
    const learnMoreButton = document.querySelector('[data-scroll-to]');
    const targetId = learnMoreButton.getAttribute('data-scroll-to');

    if (!targetId) {
      console.warn('No target ID specified in data-scroll-to');
      return;
    }

    learnMoreButton.addEventListener('click', function (e) {
      e.preventDefault();

      const targetElement = document.getElementById(targetId);
      if (!targetElement) {
        console.warn(`Target element with ID "${targetId}" not found`);
        return;
      }

      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
